// Base URL of track-api is resolved at runtime, not at build time: the backend keeps it in the
// TRACK_API_URL env of each instance and puts it into window.appSettings.baseSettings.apiUrl on
// /app/** pages. The dashboard bundle is embedded in a page that exposes the same value as
// window.TRACK_API_BASE. Standalone (IS_SEPARATED) builds and the vite dev server get neither,
// so they fall back to the production host.
const DEFAULT_TRACK_API_URL = 'https://track-api.ua-gis.com'

interface ITrackWindow {
    appSettings?: {
        baseSettings?: {
            apiUrl?: string,
            region?: string,
        },
    },
    TRACK_API_BASE?: string,
}

export const getApiBaseUrl = (): string => {
    const {appSettings, TRACK_API_BASE} = window as unknown as ITrackWindow

    const apiUrl = appSettings?.baseSettings?.apiUrl || TRACK_API_BASE

    if (!apiUrl) {
        return DEFAULT_TRACK_API_URL
    }

    // Every call site builds urls as `${BASE_TRACK_API_URL}/v1/...`, so a trailing slash would
    // produce a double one.
    return apiUrl.replace(/\/+$/, '')
}

// Region of the track1 instance serving the page ("lviv", "volyn"). Signing in has to name it:
// a login present in both databases would otherwise always get a Lviv token. Undefined outside
// track1 pages, which keeps the old lookup in track-api.
export const getSiteRegion = (): string | undefined => {
    const {appSettings} = window as unknown as ITrackWindow

    return appSettings?.baseSettings?.region || undefined
}